/**
 * KiekkoKingi section controller: store-location
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
      const sectionId = kkScript.dataset.sectionId;
      const rootId = kkScript.dataset.rootId;
      const initLocation = () => {
        const root = document.getElementById(rootId);
        if (!root || root.dataset.locationInitialized === 'true') return;
        const configNode = root.querySelector('[data-location-config]');
        if (!configNode) return;
        let config;
        try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
        root.dataset.locationInitialized = 'true';
  
        const main = root.querySelector('[data-location-status-main]');
        const detail = root.querySelector('[data-location-status-detail]');
        const todayLine = root.querySelector('[data-location-today]');
        const dayNodes = [...root.querySelectorAll('[data-location-day]')];
        const schedule = {};
        let timer;
  
        const parseTime = (value) => {
          const match = typeof value === 'string' && value.trim().match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
          return match ? Number(match[1]) * 60 + Number(match[2]) : null;
        };
        dayNodes.forEach((node) => {
          schedule[node.dataset.locationDay] = {
            label: node.dataset.dayLabel || '', nextLabel: node.dataset.nextLabel || '',
            closed: node.dataset.closed === 'true', open: parseTime(node.dataset.open), close: parseTime(node.dataset.close)
          };
        });
        const dayHours = (day) => {
          const entry = schedule[String(day)];
          if (!entry || entry.closed || entry.open === null || entry.close === null || entry.close <= entry.open) return null;
          return entry;
        };
        const pad = (value) => String(value).padStart(2, '0');
        const exactTime = (minutes) => `${pad(Math.floor(minutes / 60))}.${pad(minutes % 60)}`;
        const displayTime = (minutes) => {
          const hours = Math.floor(minutes / 60); const mins = minutes % 60;
          if (config.timeFormat === 'colon') return `${pad(hours)}:${pad(mins)}`;
          if (config.timeFormat === 'dots') return `${pad(hours)}.${pad(mins)}`;
          return mins === 0 ? String(hours) : `${hours}.${pad(mins)}`;
        };
        const range = (hours) => `${displayTime(hours.open)}–${displayTime(hours.close)}`;
        const fill = (template, values) => String(template || '').replace(/\{([a-z]+)\}/gi, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match);
        const helsinkiNow = () => {
          const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
          const parts = {};
          formatter.formatToParts(new Date()).forEach((part) => { if (part.type !== 'literal') parts[part.type] = Number(part.value); });
          const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
          const nativeDay = date.getUTCDay();
          return { weekday: nativeDay === 0 ? 7 : nativeDay, minutes: (parts.hour === 24 ? 0 : parts.hour) * 60 + parts.minute };
        };
        const nextOpening = (now, skipToday = false) => {
          for (let offset = 0; offset <= 7; offset += 1) {
            const day = ((now.weekday - 1 + offset) % 7) + 1;
            const hours = dayHours(day);
            if (!hours || (offset === 0 && (skipToday || now.minutes >= hours.open))) continue;
            return { day: offset === 0 ? config.strings.todayName : offset === 1 ? config.strings.tomorrowName : (hours.nextLabel || hours.label), time: hours.open };
          }
          return null;
        };
        const markToday = (weekday) => {
          root.querySelectorAll('[data-location-day-row]').forEach((row) => {
            const active = Number(row.dataset.locationDayRow) === weekday && config.highlightToday;
            row.classList.toggle('is-today', active);
            if (active) row.setAttribute('aria-current', 'date'); else row.removeAttribute('aria-current');
          });
        };
        const update = () => {
          let now;
          try { now = helsinkiNow(); } catch (error) {
            root.dataset.locationState = 'closed';
            if (main) main.textContent = config.strings.closed;
            if (detail) detail.textContent = config.strings.fallback;
            if (todayLine) todayLine.textContent = config.strings.fallback;
            return;
          }
          const today = dayHours(now.weekday);
          const automaticallyOpen = Boolean(today && now.minutes >= today.open && now.minutes < today.close);
          let state = automaticallyOpen ? 'open' : 'closed';
          if (config.manualMode === 'open') state = 'open';
          if (config.manualMode === 'closed') state = 'closed';
          if (config.manualMode === 'exception') state = 'exception';
          root.dataset.locationState = state;
  
          let mainText = state === 'open' ? config.strings.open : state === 'exception' ? config.strings.exception : config.strings.closed;
          let detailText = '';
          if (config.manualMode !== 'auto') {
            mainText = config.manualMain || mainText;
            detailText = config.manualDetail || config.strings.fallback;
          } else if (automaticallyOpen && today) {
            detailText = fill(config.strings.closes, { time: exactTime(today.close) });
          } else {
            const next = nextOpening(now);
            detailText = next ? fill(config.strings.opens, { day: next.day, time: exactTime(next.time) }) : config.strings.fallback;
          }
          if (main) main.textContent = mainText;
          if (detail) detail.textContent = detailText;
          if (todayLine) todayLine.textContent = today ? fill(config.strings.today, { hours: range(today) }) : config.strings.todayClosed;
          markToday(now.weekday);
        };
        const scheduleUpdate = () => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => { update(); scheduleUpdate(); }, Math.max(1000, 60000 - (Date.now() % 60000) + 50));
        };
        const onVisibility = () => { if (!document.hidden) { update(); scheduleUpdate(); } };
        document.addEventListener('visibilitychange', onVisibility);
        update(); scheduleUpdate();
        root.locationCleanup = () => {
          window.clearTimeout(timer); document.removeEventListener('visibilitychange', onVisibility);
          delete root.locationCleanup; delete root.dataset.locationInitialized;
        };
      };
      const matches = (event) => event.detail && String(event.detail.sectionId) === String(sectionId);
      const onLoad = (event) => { if (matches(event)) initLocation(); };
      const onUnload = (event) => {
        if (!matches(event)) return;
        const root = document.getElementById(rootId); if (root && root.locationCleanup) root.locationCleanup();
        document.removeEventListener('shopify:section:load', onLoad); document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:load', onLoad);
      document.addEventListener('shopify:section:unload', onUnload);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLocation, { once: true }); else initLocation();
    })();
})();